import {mapState, mapGetters, mapActions} from "vuex";
import inactiveTimeout from "@/services/inactive-timeout.service"
import { install, gtag } from 'ga-gtag';
import axios from 'axios'

export default {
  data() {
    return {
      drawer: false,
      mainForm: [],
      idleCounter: 0,
      idleCounterDialog: false,
      timerCount: 60,
      counterReset: null,
      idleTime: 0
    };
  },

  components: {
    LoadingOverlay: () => import('@/components/LoadingOverlay.vue'),
    Alert: () => import('@/components/Alerts/Alert.vue'),
    Confirmation: () => import('@/components/Alerts/Confirmation.vue')
  },

  computed: {
    ...mapState(["navItems", "navItemsAdmin", "loadingOverlayStatus"]),

    ...mapGetters("profile", {
      user: "userInfo",
      isAdmin: "isAdmin",
    }),

    ...mapGetters("confirmation", {
      "showConfirmation": "show"
    }),

    ...mapGetters(["getFirebaseConfig", "title", "overlayMessage"]),

    isAuthenticated() {
      return this?.getFirebaseConfig?.auth?.currentUser?.emailVerified || false
    },

    showHamburger() {
      return this.isAuthenticated && this.isAdmin && !this.ignoreAuth
    },

    currentRouteName() {
      return this.$route.name;
    },

    ignoreAuth() {
      return ['sign-in', 'verify-user', 'create-user'].includes(this.$route.name)
    },

    time: function () {
      return this.date.format('mm:ss');
    }
  },

  async created() {
    this.toggleLoadingOverlayStatus(true)
    this.installAnalyics()
  },

  async mounted() {
    this.setBaseUrl(window.location.origin);
    const timeoutData = await inactiveTimeout(this.getFirebaseConfig.db)
    this.idleTime = timeoutData.timeout * 60000
    addEventListener("mousemove", () => {
      window.clearTimeout(this.idleCounter)
      this.idleCounter = window.setTimeout(() => {
        this.idleCounter = 0
        if (this.user.first_name) {
          this.idleCounterDialog = true
          this.counterReset = setInterval(() => {
            if (this.timerCount > 0) {
              this.timerCount--
            } else if (this.timerCount === 0) {
              this.idleCounterDialog = false
              this.userSignOut({router: this.$router});
            }
          }, 1000);
        }
      }, this.idleTime)
    })
    this.toggleLoadingOverlayStatus(false)
  },

  methods: {
    ...mapActions(["setBaseUrl", "toggleLoadingOverlayStatus"]),

    ...mapActions("profile", ["establishUserAuth", "userSignOut"]),

    ...mapActions('prices', ['setPrices']),

    async installAnalyics() {
      const { VUE_APP_REGION, VUE_APP_PROJECT } = process.env 
      const secretBaseUrl = `https://${VUE_APP_REGION}-${VUE_APP_PROJECT}.cloudfunctions.net/getSecretV2`
      const analyticsData = (await axios.get(`${secretBaseUrl}?key=google-analytics-id`)).data
      install(analyticsData.gaID, { send_page_view: false })
      gtag('config', analyticsData.awID)
      this.$store.dispatch('analytics/init', analyticsData)
    },
    backClick() {
      history.back();
    },
    logoutAction() {
      this.userSignOut({router: this.$router});
      window.clearTimeout(this.idleCounter)
      this.idleCounterDialog = false
      this.idleCounter = 0
    },
    continueWork() {
      window.clearTimeout(this.idleCounter)
      window.clearInterval(this.counterReset)
      this.idleCounterDialog = false
      this.idleCounter = 0
      this.timerCount = 60
    },

    async signOutUser() {
      this.toggleLoadingOverlayStatus(true);
      await this.userSignOut({ redirect: true });
      this.toggleLoadingOverlayStatus(false);
      this.$router.push({name: 'sign-in'})
    },

    navigateSignInUp() {
      const name = this.currentRouteName === 'sign-in' ? 'create-user' : 'sign-in';
      this.$router.push({name}).catch(() => {});
    }
  },
}